import 'whatwg-fetch';
import Promise from 'es6-promise';
if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}
let baseUrl = document.location.origin+(window.location.pathname.substr(0,3) === '/v5'?'/v5':'')+'/webapi/flow/getnextscreen';
class ScreenService{
    static handleRedirect(doFetch){
        return doFetch().then(response => 
        {
            if(response.url && response.url != baseUrl){
                baseUrl = response.url;
                return doFetch();
            }
            return new Promise((resolve, reject) => {resolve(response);});
        }).catch((error) => { return new Promise((resolve, reject) => {reject(error);})});

    }

    static getScreendata(currentScreenData, success = true){
        if(!window.Promise){
            window.Promise = Promise.Promise;
        }
        let state = null;

        if(currentScreenData){
            let valueProps = Object.keys(currentScreenData.Values);
            if(valueProps.length){
                currentScreenData.Values = Object.assign(...valueProps
                                            .map(k => 
                                            (
                                                {[k]: (currentScreenData.Values[k] instanceof Object)?JSON.stringify(currentScreenData.Values[k]):currentScreenData.Values[k]}
                                            )
                                        ));
            }
            state = {
                success: success,
                data: currentScreenData
            };
        } 

        return this.handleRedirect(            
            () => fetch(baseUrl, {
                method: 'Post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'                    
                },
                redirect: 'follow',
                credentials: 'same-origin',
                body: JSON.stringify({
                            "callingUrl": document.location.href,
                            currentScreenState: state
                    })
            })
        );      

    }
}

export default ScreenService;


/** WEBPACK FOOTER **
 ** ./src/services/screenService.js
 **/